import * as angular from "angular";
import {IScope} from "angular";
import {LqbUpdateDTO} from "../../model/User";
import './lqb-user-update-restult.component.scss';

interface LqbUserUpdateResultScope extends IScope {
    closeDialog: () => void;
    updates: LqbUpdateDTO[]
}

export class LqbUserUpdateResultComponent {

    static instance = ($event, updates: LqbUpdateDTO[]): angular.material.IDialogOptions => ({
        template: require('./lqb-user-update-result.component.html'),
        controller: ['$scope', '$mdDialog', 'updates', LqbUserUpdateResultComponent],
        fullscreen: true,
        parent: angular.element(document.body),
        targetEvent: $event,
        clickOutsideToClose: true,
        locals: {
            updates: updates
        }
    });

    private $scope: LqbUserUpdateResultScope;
    private $mdDialog: angular.material.IDialogService;

    constructor($scope: LqbUserUpdateResultScope,
                $mdDialog: angular.material.IDialogService,
                updates: LqbUpdateDTO[]) {
        $scope.updates = updates;
        this.$mdDialog = $mdDialog;
        this.$scope = $scope;
        this.$scope.closeDialog = this.closeDialog;
    }

    closeDialog = () => {
        this.$mdDialog.cancel();
    }

}